/**
 * @file dialog-context.js
 * @description Contexto de dialog (CRA)
 */

import { createContext } from "react"

/**
 * Contexto de dialog
 */
export const DialogContext = createContext(null)
